import { render, staticRenderFns } from "./ErrorLabel.vue?vue&type=template&id=19952a0c"
import script from "./ErrorLabel.vue?vue&type=script&lang=ts"
export * from "./ErrorLabel.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./ErrorLabel.vue?vue&type=custom&index=0&blockType=comments"
if (typeof block0 === 'function') block0(component)

export default component.exports